<template>
    <div>
    <b-card style="position: relative">
      <div v-if="$store.getters['maintenances.device.list/isLoading']" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <div class="m-2">
        <b-row>
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select 
                :value="$store.getters['maintenances.device.list/perPage']"
                @input="value => {
                  $store.commit('maintenances.device.list/updatePerPage', { value })
                  $store.dispatch('maintenances.device.list/fetchList')
                }"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="$store.getters['maintenances.device.list/perPageOptions']"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"/>
            <label>{{ $t('entries') }}</label>
          </b-col>
        </b-row>
      </div>
  
      <b-table 
        :items="$store.getters['maintenances.device.list/list']" 
        :fields="$store.getters['maintenances.device.list/tableColumns']"
        class="position-relative" 
        primary-key="id"
        empty-text="No matching records found"
        show-empty
        responsive
        >
  
        <template #cell(id)="data"> {{ data.index + 1 }} </template>
  
        <template #cell(actions)="data">
  
          <b-dropdown 
            class="actionIcon" 
            variant="link" 
            no-caret 
            :right="$store.state.appConfig.isRTL"
            v-if="($store.getters['auth/user'].permissions.includes('maintenances.show')) || 
            ($store.getters['auth/user'].permissions.includes('maintenances.done'))" 
          >
  
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
            </template>
  
            <b-dropdown-item 
              :to="{ name: 'maintenances.show', params: { id: data.item.id } }"
              v-if="($store.getters['auth/user'].permissions.includes('maintenances.show'))" 
            >
              <feather-icon icon="ListIcon" />
              <span class="align-middle ml-50">{{ $t('MAINTENANCES_DETAILS_LABEL') }}</span>
            </b-dropdown-item>
  
            <b-dropdown-item 
              @click='() => $store.dispatch("maintenances.device.list/done" , data.item)'
              v-if="($store.getters['auth/user'].permissions.includes('maintenances.done'))" 
            >
              <feather-icon icon="ToolIcon" />
              <span class="align-middle ml-50">{{ $t('MAINTENANCES_DONE_LABEL') }}</span>
            </b-dropdown-item>
  
          </b-dropdown>
        </template>
  
      </b-table>
  
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $store.getters['maintenances.device.list/tableMeta'] }}</span>
          </b-col>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination 
                :value="$store.getters['maintenances.device.list/currentPage']"
                @input="value => {
                  $store.commit('maintenances.device.list/updateCurrentPage', { value })
                  $store.dispatch('maintenances.device.list/fetchList')
                }"
                :total-rows="$store.getters['maintenances.device.list/tableTotalRows']"
                :per-page="$store.getters['maintenances.device.list/perPage']" 
                first-number 
                last-number
                class="mb-0 mt-1 mt-sm-0" 
                prev-class="prev-item" 
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18"/>
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18"/>
              </template>
            </b-pagination>
  
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  </template>
  
  <script>
  
  import { OrbitSpinner } from 'epic-spinners'
  
  import {
    BButton, 
    BCard, 
    BCol,
    BForm,
    BFormGroup, 
    BFormInput,
    BInputGroup, 
    BRow, 
    BAlert, 
    BTabs, 
    BTab, 
    BCardText, 
    BTable, 
    BPagination, 
    BDropdown, 
    BDropdownItem
  } from 'bootstrap-vue'
  
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import { onUnmounted } from '@vue/composition-api'
  import store from '@/store'
  import StoreModule from '@/app/maintenances/list.store.js'
  
  export default {
    name: 'list',
    components: { 
      BRow, 
      BCard, 
      BCol, 
      BAlert, 
      BTable,BPagination,
      BFormGroup, 
      BFormInput, 
      BInputGroup, 
      BForm, 
      BButton, 
      BTabs, 
      BCardText, 
      BTab, 
      vSelect, 
      OrbitSpinner, 
      BDropdown,
      BDropdownItem
    },
    directives: { Ripple },
    setup( props, { root }) {
  
      const STORE_MODULE = 'maintenances.device.list'
      store.registerModule(STORE_MODULE, StoreModule)
  
      onUnmounted(() => {
        if (store.hasModule(STORE_MODULE))
            store.unregisterModule(STORE_MODULE)
      })
  
      store.commit('maintenances.device.list/updateRoot', root)
      store.commit('maintenances.device.list/updateDeviceId', root.$router.currentRoute.params.id)
      store.dispatch('maintenances.device.list/fetchList')
  
      return {}
  
    }
  
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  .actionIcon>button {
    padding: 0;
  }
  </style>
  